<template>
    <v-container fluid fill-height>

        <v-layout class="profile">
            <v-flex xs12>

                <v-toolbar flat color="white">
                    <v-toolbar-title>Профиль </v-toolbar-title>
                    <v-divider
                            class="mx-2"
                            inset
                            vertical
                    >
                    </v-divider>

                    <v-spacer>
                    </v-spacer>

                    <v-btn @click="openChangePassword" color="info" dark class="mb-2"> Изменить пароль</v-btn>
                    <v-dialog v-model="changePassDialog" max-width="500px">
                        <v-card>
                            <v-card-title>
                                <span class="headline"> Изменить пароль </span>
                            </v-card-title>
                            <v-alert
                                    :value="changePassSuccessAlert"
                                    dismissible
                                    type="success"
                            >
                                {{changePassSuccessText}}
                            </v-alert>
                            <v-alert
                                    :value="changePassErrorAlert"
                                    color="error"
                                    icon="warning"

                            >
                                {{changePassErrorText}}
                            </v-alert>
                            <v-form
                                    ref="changePassForm"
                                    v-model="changePassValid"
                                    lazy-validation
                            >
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 field-block>
                                                <div v-if="changePass.oldPassword && changePass.oldPassword.length >= 76 && changePass.oldPassword.length < 100" class='max-length-block'>Осталось {{100 - changePass.oldPassword.length}} символов</div>

                                                <v-text-field
                                                        :append-icon="showPass1 ? 'visibility_off' : 'visibility'"
                                                        :type="showPass1 ? 'text' : 'password'"
                                                        v-model="changePass.oldPassword"
                                                        :rules="oldPasswordRules"
                                                        maxlength="100"
                                                        required
                                                        @click:append="showPass1 = !showPass1"
                                                >
                                                    <template slot="label">
                                                        Старый пароль <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 field-block>
                                                <div v-if="changePass.newPassword && changePass.newPassword.length >= 76 && changePass.newPassword.length < 100" class='max-length-block'>Осталось {{100 - changePass.newPassword.length}} символов</div>

                                                <v-text-field
                                                        :append-icon="showPass2 ? 'visibility_off' : 'visibility'"
                                                        :type="showPass2 ? 'text' : 'password'"
                                                        v-model="changePass.newPassword"
                                                        :rules="passwordRules"
                                                        maxlength="100"
                                                        required
                                                        @click:append="showPass2 = !showPass2"
                                                >
                                                    <template slot="label">
                                                        Новый пароль <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 field-block>
                                                <div v-if="changePass.confirmPassword && changePass.confirmPassword.length >= 76 && changePass.confirmPassword.length < 100" class='max-length-block'>Осталось {{100 - changePass.confirmPassword.length}} символов</div>

                                                <v-text-field
                                                        :append-icon="showPass3 ? 'visibility_off' : 'visibility'"
                                                        :type="showPass3 ? 'text' : 'password'"
                                                        v-model="changePass.confirmPassword"
                                                        :rules="passwordRules"
                                                        maxlength="100"
                                                        :error-messages="changePass.newPassword != changePass.confirmPassword ? 'Подтверждение пароля  не совпадает' : ''"
                                                        required
                                                        @click:append="showPass3 = !showPass3"
                                                >
                                                    <template slot="label">
                                                        Подтвердите новый Пароль <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" flat @click="changePassClose">Отменить</v-btn>
                                    <v-btn color="success" flat @click="changePassword">Сохранить</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>

                    <v-btn @click="editUser" color="info" dark class="mb-2"> Редактировать</v-btn>
                    <v-dialog v-model="userDialog" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline"> Редактировать</span>
                            </v-card-title>
                            <v-alert
                                    :value="successAlert"
                                    dismissible
                                    type="success"
                            >
                                {{successText}}
                            </v-alert>
                            <v-alert
                                    :value="errorAlert"
                                    color="error"
                                    icon="warning"

                            >
                                {{errorText}}
                            </v-alert>
                            <v-form
                                    ref="userForm"
                                    v-model="userValid"
                                    lazy-validation
                            >
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 field-block>
                                                <div v-if="userItem.fullname.length >= 76 && userItem.fullname.length < 100" class='max-length-block'>Осталось {{100 - userItem.fullname.length}} символов</div>

                                                <v-text-field v-model="userItem.fullname" :rules="requiredRules"  :error-messages="inputErrors.fullname" maxlength="100" required>
                                                    <template slot="label">
                                                        ФИО <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 field-block>
                                                <div v-if="userItem.email.length >= 76 && userItem.email.length < 100" class='max-length-block'>Осталось {{100 - userItem.email.length}} символов</div>

                                                <v-text-field v-model="userItem.email" :rules="emailRules" :error-messages="inputErrors.email" maxlength="100" required>
                                                    <template slot="label">
                                                        Адрес элетронной почты <span class='error-file'>*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6>
                                                <v-text-field :value="userItem.username"  label="Логин сотрудника" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 md6>
                                                <v-text-field :value="showRole(userItem.role)" label="Роль" disabled></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" flat @click="userClose">Отменить</v-btn>
                                    <v-btn color="success" flat @click="userSave">Сохранить</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>

                </v-toolbar>

                <v-container fluid grid-list-md>
                   <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                        <p class="filed-title">Логин сотрудник</p>
                        <div class="filed-block">{{ user_data.username }}</div>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                        <p class="filed-title">ФИО</p>
                        <div class="filed-block">{{ user_data.fullname }}</div>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                        <p class="filed-title">Адрес элетронной почты</p>
                        <div class="filed-block">{{ user_data.email }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                        <p class="filed-title">Роль</p>
                        <div class="filed-block">{{ showRole(user_data.role) }}</div>
                    </v-flex>

                </v-layout>
                </v-container>

            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import axios from 'axios'
    export default{

        data(){
            return{
                backUrl: null,
                user_data: [],
                role:'',
                successText:'',
                errorText:'',
                errorAlert:false,
                successAlert:false,

                changePassSuccessAlert:false,
                changePassErrorAlert:false,
                changePassSuccessText:'',
                changePassErrorText:'',
                userDialog: false,
                changePassDialog: false,
                changePassValid: true,
                userValid: true,

                token:'',

                user_id: '',
                userItem: {
                    fullname: '',
                    email: '',
                },
                changePass:{
                    oldPassword:'',
                    newPassword:'',
                    confirmPassword:''
                },
                inputErrors:[],

                showPass1: false,
                showPass2: false,
                showPass3: false,

                requiredRules: [
                    v => !!v || 'Значение должно быть заполнено',
                ],
                emailRules: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                    },
                ],
                oldPasswordRules: [
                    (v) => !!v || 'Значение должно быть заполнено',
                ],
                passwordRules: [
                    (v) => !!v || 'Значение должно быть заполнено',
                     v => (v && v.length >= 5) || 'Пароль должен быть длиной от 5 до 100 символов',
                ],


            }
        },

        created () {
            this.token = localStorage.getItem('token');
            this.user_id = localStorage.getItem('user_id');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.getUser(this.user_id);
        },

        watch: {
            changePassDialog (val) {
                val || this.changePassClose()
            },
            userDialog (val) {
                val || this.userClose()
            },
        },
        methods:{

            editUser () {
                this.userItem = Object.assign({}, this.user_data)
                this.userDialog = true

            },

            openChangePassword (){
                this.changePassDialog = true
            },

            changePassword (){
                if (this.$refs.changePassForm.validate()) {
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/users/changePassword',
                        withCredentials: true,
                        data: {
                            oldPassword: this.changePass.oldPassword,
                            newPassword: this.changePass.confirmPassword,
                        }
                    }).then(() => {

                        this.changePassErrorAlert = false
                        this.changePassSuccessText = 'Пароль успешно изменен'
                        this.changePassSuccessAlert = true
                        setTimeout(() => {
                            this.changePassClose()
                        }, 1500)
                    })
                    .catch(error =>{
                            if(error.response.data.rows.newPassword){
                                this.changePassErrorText = error.response.data.rows.newPassword
                            }else if(error.response.data.rows.oldPassword){
                                this.changePassErrorText = error.response.data.rows.oldPassword
                            }

                        this.changePassErrorAlert = true
                    });
                }
            },

            getUser(id){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/users/' + id,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.user_data = response.data
                })
            },

            userSave(){
                this.inputErrors = ''
                if (this.backUrl.userForm.validate()) {
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/users',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.user_data.id,
                            uuid: this.user_data.uuid,
                            fullname: this.userItem.fullname,
                            email: this.userItem.email,
                        },
                    }).then(response => {
                        this.user_data = JSON.parse(response.data.objectJson)

                        this.inputErrors = ''
                        this.successText = 'Успешно изменен'
                        this.successAlert = true
                        this.getUser(this.user_data.id)
                        setTimeout(() => {
                            this.userClose()
                        }, 1500)
                    })
                    .catch(error => {
                        let errors = error.response.data.rows;
                        this.inputErrors = errors

                    });
                }
            },

            userClose () {
                    this.userDialog = false
                    setTimeout(() => {
                        this.successAlert = false
                        this.successText = ''
                        this.errorText = ''
                        this.errorAlert = false
                        this.inputErrors = []
                    }, 300)
            },

            changePassClose () {
                this.changePassDialog = false
                setTimeout(() => {
                    this.$refs.changePassForm.reset()
                    this.changePassErrorText = ''
                    this.changePassErrorAlert = false
                    this.changePassSuccessText = ''
                    this.changePassSuccessAlert = false
                    this.changePass = {}
                }, 300)
            },

            showRole(role){
                if (role == "ROLE_ADMIN"){
                    return "Администратор"
                }else if (role == "ROLE_EXPERT"){
                    return "Эксперт"
                }else if (role == "ROLE_CUSTOMER_ADMIN"){
                    return "Администратор"
                }else{
                    return "Сотрудник"
                }
            },
        }
    }
</script>
<style>
    .profile .v-list__tile__action{
        width: 220px;
    }
    .v-divider--inset:not(.v-divider--vertical) {
        margin-left: 220px!important;
        max-width: calc(100% - 220px)!important;
    }
    .profile{
        background: #fff;
    }
</style>